export default "<p>error404 works!</p>\r\n"